<template>
	<StoryblokComponent v-if="story" :blok="story.content" />
</template>

<script setup lang="ts">
	import type {PageTypeHomepageStoryblok} from '~/storyblok/types';

	const fullSlug = '_globus-cz';
	const {data: story, error} = await useSingleStoryFetch<PageTypeHomepageStoryblok>(fullSlug);

	if (!story.value || error.value) {
		await tryDynamicRedirectOrShowError(error);
	}
</script>
